var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dot",style:(_vm.style),on:{"click":function($event){return _vm.clicked()}}})}
var staticRenderFns = []

export { render, staticRenderFns }